<canvas #mapCanvas></canvas>
<span [matMenuTriggerFor]="contextMenu"></span>
<mat-menu #contextMenu="matMenu" class="map-context-menu">
  @if (contextMenu) {
    @for (menuItem of contextMenuOptions; track menuItem) {
      <button mat-menu-item (click)="menuItem.click()"
      [disabled]="menuItem.disabled">{{menuItem.option}}</button>
    }
  }
</mat-menu>
